export const DEFAULT_UPLOAD_WIDGET_HEADING = 'Ready to start a new check?'
export const DEFAULT_UPLOAD_WIDGET_SUBHEADING = ''

export const MODAL_UPLOAD_WIDGET_HEADING = 'Upload your paper'
export const MODAL_UPLOAD_WIDGET_SUBHEADING = ''

export interface PricingType {
  freeTrial: boolean
  price: string
  pricingExperiment: string
  basePrice: number
}

export const titleTemplate = {
  base: 'Plagiarism and grammar checker',
  pages: {
    editor: 'Editor',
    notFound: 'Paper not found',
    root: 'Homepage',
    termsAndConditions: 'Terms and conditions',
    plans: 'Plans',
    demo: 'Demo',
  },
  separator: ' - ',
}



// WEBPACK FOOTER //
// ./src/state/site/constants.ts